import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Register";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Indiquez votre email : nous vous envoyons un lien pour choisir un nouveau mot de passe."
    >
      {sent ? (
        <div data-testid="forgot-success" className="space-y-6">
          <p className="text-sm text-[#5E5356] bg-[#F5E6E8] rounded-2xl px-5 py-4 leading-relaxed">
            Si ce compte existe, un email de réinitialisation vient d'être envoyé. Le lien est
            valable une heure.
          </p>
          <Link to="/connexion" className="text-sm text-[#B76E79] hover:underline">
            Retour à la connexion
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-6" data-testid="forgot-form">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.16em] text-[#5E5356]">Email</Label>
            <Input
              data-testid="forgot-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 rounded-xl border-[#E8D7D0] focus-visible:ring-[#B76E79]"
            />
          </div>
          {error && (
            <p data-testid="forgot-error" className="text-sm text-red-600 bg-red-50 rounded-xl px-4 py-3">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="forgot-submit-btn"
            className="w-full h-12 rounded-full bg-[#B76E79] hover:bg-[#A25D67] text-white text-base"
          >
            {loading ? "Envoi…" : "Envoyer le lien"}
          </Button>
          <Link to="/connexion" className="text-sm text-[#B76E79] hover:underline block">
            Retour à la connexion
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
